export const DEFAULT_DISCOUNT_PERCENTAGES = Object.freeze([0, 5, 10, 15, 20]);

export const toggleDiscountPercentage = (
    currentPercentage,
    selectedPercentage
) => {
    const normalizedSelection = Number(selectedPercentage);

    return Number(currentPercentage) === normalizedSelection
        ? 0
        : normalizedSelection;
};

export const buildDiscountPayload = ({
    fixedDiscountAmount = 0,
    percentageDiscount = 0,
} = {}) => {
    const fixedAmount = Number(fixedDiscountAmount);
    if (Number.isFinite(fixedAmount) && fixedAmount > 0) {
        return { discount_amount: fixedAmount };
    }

    const percentage = Number(percentageDiscount);
    if (Number.isFinite(percentage) && percentage > 0) {
        return { discount_percentage: percentage };
    }

    return { discount_amount: 0, discount_percentage: 0 };
};

export const requiresDiscountApproval = ({
    elevatedPrivileges = false,
    fixedDiscountAmount = 0,
    percentageDiscount = 0,
    previewDiscountAmount = 0,
    presetDiscountAmount = 0,
    presetDiscountPercentage = 0,
} = {}) => {
    if (!elevatedPrivileges) return false;

    const fixedAmount = Number(fixedDiscountAmount);
    if (Number.isFinite(fixedAmount) && fixedAmount > 0) {
        return fixedAmount > 1;
    }

    const percentage = Number(percentageDiscount);
    if (!Number.isFinite(percentage) || percentage <= 0) return false;

    const previewAmount = Number(previewDiscountAmount);
    const presetAmount =
        Number.isFinite(previewAmount) && previewAmount > 0
            ? previewAmount
            : Number(presetDiscountAmount);
    const presetPercentage = Number(presetDiscountPercentage);
    const isUnchangedPreset =
        Number.isFinite(presetAmount) &&
        presetAmount > 0 &&
        Number.isFinite(presetPercentage) &&
        Math.abs(percentage - presetPercentage) < 0.005;

    // Table Order exposes its stored discount as an amount. The payment page
    // derives a percentage from it, so automatic rounding such as 10.5 -> 10
    // otherwise looks like a 4.76% cashier discount. Apply the approval limit
    // to the preview's monetary amount (or the stored amount as a fallback)
    // unless the cashier selects another percentage.
    if (isUnchangedPreset) {
        return presetAmount > 1;
    }

    return percentage > 1;
};

export const resolvePosProfileDiscountPercentages = (configuredRows) => {
    if (!Array.isArray(configuredRows) || configuredRows.length === 0) {
        return [...DEFAULT_DISCOUNT_PERCENTAGES];
    }

    const percentages = [];
    const seen = new Set();

    configuredRows.forEach((row) => {
        const rawValue =
            row && typeof row === "object" ? row.discount_percentage : row;
        if (
            rawValue === null ||
            rawValue === undefined ||
            String(rawValue).trim() === ""
        ) {
            return;
        }

        const percentage = Number(rawValue);
        if (
            !Number.isFinite(percentage) ||
            percentage < 0 ||
            percentage > 100 ||
            seen.has(percentage)
        ) {
            return;
        }

        seen.add(percentage);
        percentages.push(percentage);
    });

    return percentages.length
        ? percentages
        : [...DEFAULT_DISCOUNT_PERCENTAGES];
};
